import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from './../actions/customer.actions';
import * as CasesActions from './../actions/customer.cases.actions';
export var INITIAL_STATE = Immutable({
  filterData: {
    includeStatusFilter: [],
    pageSizePreference: null
  },
  pageNumber: 1
});
export default function CasesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case CasesActions.SET_CURRENT_PAGE:
      return state.set('pageNumber', payload);
    case CasesActions.SET_CASE_STATUS_FILTER:
      return state.setIn(['filterData', 'includeStatusFilter'], payload);
    case CasesActions.SET_CASE_PAGE_SIZE_PREFERENCE:
      return state.setIn(['filterData', 'pageSizePreference'], payload);
    case RESET_CUSTOMER_RECOVERABLE:
    case CasesActions.REMOVE_CASES_FILTER:
      return INITIAL_STATE;
    default:
      return state;
  }
}